import { useTranslation } from 'react-i18next';
import { mainSiteUrl } from '@/mocks/categories';

const featuredProducts = [
  {
    name: 'Tech Gadget',
    nameRu: 'Гаджет',
    price: '$28',
    rating: '4.9',
    color: 'bg-accent-100',
    image: 'https://readdy.ai/api/search-image?query=Minimal%20white%20wireless%20earbuds%20on%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20warm%20lighting%2C%20elevated%20editorial%2C%20neutral%20aesthetic%2C%20no%20text&width=400&height=500&seq=feat-tech-01&orientation=portrait',
    url: mainSiteUrl,
  },
  {
    name: 'Sneakers Pro',
    nameRu: 'Кроссовки',
    price: '$35',
    rating: '4.8',
    color: 'bg-primary-50',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20minimal%20sneakers%20on%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20warm%20lighting%2C%20elevated%20editorial%20style%2C%20neutral%20tones%2C%20no%20text&width=400&height=500&seq=feat-shoes-02&orientation=portrait',
    url: mainSiteUrl,
  },
  {
    name: 'Hoodie Luxe',
    nameRu: 'Худи',
    price: '$22',
    rating: '4.7',
    color: 'bg-secondary-100',
    image: 'https://readdy.ai/api/search-image?query=Premium%20beige%20hoodie%20flat%20lay%20on%20cream%20background%2C%20minimal%20product%20photography%2C%20soft%20warm%20lighting%2C%20clean%20editorial%2C%20neutral%20palette%2C%20no%20text&width=400&height=500&seq=feat-hoodie-03&orientation=portrait',
    url: mainSiteUrl,
  },
  {
    name: 'Bag Classic',
    nameRu: 'Сумка',
    price: '$32',
    rating: '4.9',
    color: 'bg-accent-100',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20minimal%20tote%20bag%20on%20cream%20background%2C%20clean%20product%20photography%2C%20soft%20warm%20lighting%2C%20elevated%20editorial%2C%20neutral%20aesthetic%2C%20no%20text&width=400&height=500&seq=feat-bag-04&orientation=portrait',
    url: mainSiteUrl,
  },
];

export default function FeaturedProducts() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            {t('featured.title')}
          </h2>
          <p className="text-sm text-foreground-600 mt-2">
            {t('featured.subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-2 lg:grid-cols-4 gap-5">
          {featuredProducts.map((product) => (
            <a
              key={product.name}
              href={product.url}
              target="_blank"
              rel="noopener nofollow"
              className="group rounded-xl overflow-hidden cursor-pointer"
            >
              <div className={`aspect-[3/4] rounded-xl overflow-hidden ${product.color}`}>
                <img
                  src={product.image}
                  alt={`${product.name} - YOYBUY spreadsheet find`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  title={`${product.nameRu} в YOYBUY подборке`}
                />
              </div>
              <div className="px-1 pt-3 pb-1">
                <p className="text-sm font-medium text-foreground-800">{product.name}</p>
                <div className="flex items-center justify-between mt-1">
                  <span className="text-sm font-semibold text-primary-600">{product.price}</span>
                  <span className="text-xs text-foreground-500 flex items-center gap-0.5">
                    <i className="ri-star-fill text-accent-500 text-xs"></i>
                    {product.rating}
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}